import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef } from "vue"

import { ref, computed, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import SelectStationNature from '@/components/SelectStationNature.vue'
import InfoTooltip from '@/components/InfoTooltip.vue'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { AddEssDevice, getEvseModelInfo, UpdateEssDevice, upsertEvse } from '@/api/evses'
import { ElMessage } from 'element-plus'
import FormRulesFactory from '@/common/formRules'
import AdvancedSettingContainer from '@/components/AdvancedSettingContainer.vue'

import { defineComponent, nextTick } from 'vue'
import { cloneDeep } from 'lodash'

const __default__ = defineComponent({
  name: 'EvseDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  opeartorID: {
    type: String,
    default: '',
  },
  stationId: {
    type: String,
    default: '',
  },
  isEdit: {
    type: Boolean,
  },
  evseInfo: {
    type: Object,
    default() {
      return {}
    },
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const { evseProtocols, essDeviceType, evseNetworkingModes } = useProtocolEnums()
const evseFormRules = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorId', 'stationId', 'protocolVendor', 'networking'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(
    ['alias', 'firmwareVersion', 'model', 'sn'],
    'inputEmpty',
    'inputInvalid',
  ),
  ...FormRulesFactory.generateCustomRules(['firmwareVersionCode'], 'inputEmpty', 'inputInvalid', {
    type: 'number',
  }),
})

const { tl, t } = useI18nTl('Evses')



let subsForm = ref()
const record = ref<Record<string, any>>({})
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    }, 300)
  })
}
const showDialog = computed({
  get: () => {
    clearValidate()
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})
const handleOperatorSelect = (item: any) => {
  console.log('item======== operator select', item)
  record.value.stationId = ''
  record.value.stationName = ''
}
const stationSelect = (item: any) => {
  record.value.stationName = item.name
}
const submit = async () => {
  await subsForm.value?.validate()
  const processedRecord = ref({ ...record.value })

  sendRequest()
    .then(() => {
      showDialog.value = false
      record.value = {}
      emit('submitted')
    })
    .catch((error: any) => {
      console.error('Error fetching table data:', error)
    })
}
const sendRequest = () => {
  return new Promise<void>((resolve, reject) => {
    if (props.isEdit) {
      UpdateEssDevice(record.value)
        .then((res: any) => {
          ElMessage.success(t(`Base.createSuccess`))
          resolve()
        })
        .catch((err: any) => {
          reject(err)
        })
    } else {
      AddEssDevice(record.value)
        .then((res: any) => {
          ElMessage.success(t(`Base.editSuccess`))
          resolve()
        })
        .catch((err: any) => {
          reject(err)
        })
    }
  })
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value = cloneDeep(props.evseInfo)
    } else {
      record.value = {
        operatorId: props.opeartorID,
        stationId: props.stationId,
      }
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: props.isEdit ? _unref(tl)('editEvse') : _unref(tl)('addEvse'),
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "50%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.edit') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        rules: evseFormRules.value,
        ref_key: "subsForm",
        ref: subsForm
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "sn",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(tl)('evseSN')), 1),
                      _createVNode(InfoTooltip, {
                        content: _ctx.$t('Evses.addEvseTip'),
                        place: "left"
                      }, null, 8, ["content"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        rows: 1,
                        modelValue: record.value.sn,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.sn) = $event)),
                        disabled: props.isEdit
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('evseName'),
                    prop: "alias",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.alias,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.alias) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('pvCapacity'),
                    prop: "alias",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.pvCapacity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.pvCapacity) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "operatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: record.value.operatorId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.operatorId) = $event)),
                        disabled: props.isEdit,
                        onChanges: handleOperatorSelect
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.station'),
                    prop: "stationId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectStation, {
                        modelValue: record.value.stationId,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.stationId) = $event)),
                        operatorId: record.value.operatorId,
                        name: record.value.stationName,
                        disabled: record.value.operatorId == '0' || !record.value.operatorId,
                        isEssStation: true,
                        onChange: stationSelect
                      }, null, 8, ["modelValue", "operatorId", "name", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('model'),
                    prop: "model",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.model,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.model) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('evseProtocol'),
                    prop: "protocolVendor",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.protocolVendor,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.protocolVendor) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseProtocols), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('deviceType'),
                    prop: "deviceType",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.deviceType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.deviceType) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(essDeviceType), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('networking'),
                    prop: "networking",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: record.value.networking,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.networking) = $event)),
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evseNetworkingModes), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: item.label,
                              value: item.value,
                              key: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('firmwareVersion'),
                    prop: "firmwareVersion",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.firmwareVersion,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((record.value.firmwareVersion) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('firmwareVersionCode'),
                    prop: "firmwareVersionCode",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "number",
                        modelValue: record.value.firmwareVersionCode,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((record.value.firmwareVersionCode) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('protocolVersion'),
                    prop: "protocolVersion",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.protocolVersion,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.protocolVersion) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})